import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgSignatureLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0H4H12H13V2H12H5V22H15.2H15.2084V22C16.2043 22.0085 17.1629 21.6214 17.8737 20.9239C18.5834 20.2276 18.9883 19.2785 19 18.2845V8.75V7.75H21V8.75V18.29V18.3005L20.9999 18.3005C20.984 19.8261 20.3634 21.2829 19.2745 22.3515C18.1866 23.419 16.72 24.0117 15.196 24H4H3V23V1V0ZM17.9036 0.970429L20.0456 3.08186L20.8338 2.23965C20.9405 2.12935 21 1.98277 21 1.83038C21 1.67799 20.9405 1.53148 20.8338 1.42118L19.5582 0.163838C19.4463 0.05869 19.2977 0 19.1431 0C18.9885 0 18.8398 0.05869 18.7279 0.163838L17.9036 0.970429ZM17.9036 0.970429L12.4068 6.49356L12.0037 8.74725C11.9972 8.78135 11.9993 8.81655 12.0097 8.84969C12.0201 8.88283 12.0386 8.91291 12.0635 8.93744C12.0884 8.96197 12.1189 8.98017 12.1525 8.99043C12.1861 9.0007 12.2218 9.00274 12.2564 8.99637L14.5428 8.59898L20.039 3.07604L17.9036 0.970429ZM8 7C7.44772 7 7 7.44772 7 8C7 8.55229 7.44772 9 8 9H10C10.5523 9 11 8.55229 11 8C11 7.44772 10.5523 7 10 7H8ZM7 5C7 4.44772 7.44772 4 8 4H10C10.5523 4 11 4.44772 11 5C11 5.55228 10.5523 6 10 6H8C7.44772 6 7 5.55228 7 5ZM14.1617 16.8241C14.2238 16.8271 14.3038 16.8338 14.3916 16.8412C14.686 16.866 15.0679 16.8981 15.1531 16.8224C15.3896 16.7836 15.6045 16.6623 15.7597 16.4797C15.9148 16.297 16 16.065 16 15.8254C16 15.5857 15.9148 15.3537 15.7597 15.1711C15.6045 14.9885 15.3896 14.8671 15.1531 14.8284H14.8208C14.7804 14.8284 14.7354 14.842 14.6911 14.8555C14.604 14.8819 14.5192 14.9076 14.4751 14.8284C13.7307 14.177 12.8267 14.9349 12.614 15.6793H12.4279C12.3782 15.1462 12.2894 14.6176 12.1621 14.0975C11.6968 12.1567 10.8328 11 9.88897 11C9.54854 10.9978 9.22015 11.1263 8.97164 11.359C8.6696 11.6385 8.48839 12.0249 8.46648 12.4358C8.39522 13.84 8.75723 15.2322 9.50341 16.4238C8.92897 16.6672 8.45841 17.1044 8.17407 17.6597C7.97356 18.1126 7.94528 18.6232 8.09439 19.0955C8.16281 19.4687 8.35985 19.8061 8.65131 20.049C8.94277 20.2919 9.31014 20.4248 9.68953 20.4248C9.80882 20.4379 9.9292 20.4379 10.0485 20.4248C10.6586 20.2997 11.2127 19.9827 11.6303 19.5207L11.7765 19.3214C12.1171 18.8304 12.336 18.2657 12.4147 17.6733H12.5874C12.7866 17.6596 12.9865 17.6596 13.1857 17.6733C13.8191 17.6733 14.0592 17.2076 14.1617 16.8241ZM9.90227 13.2465C9.4503 13.9511 10.4738 15.6125 10.4738 15.6125V15.6391C10.4738 15.6391 10.5802 13.8447 9.90227 13.2465ZM10.6333 17.846C10.2345 17.6998 8.22729 18.524 9.55663 19.1753V19.2019C10.1548 19.4811 11.3379 18.2182 10.6333 17.846Z"
      fill={props.color}
    />
  </svg>
);

SvgSignatureLarge.displayName = 'SvgSignatureLarge';
const SignatureLarge = withForgeIconProps(SvgSignatureLarge, {
  name: 'Signature',
  usage: 'Use to represent a signature or a signed document',
  related: 'Approved, Edit',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default SignatureLarge;
